import { Navigate, useLocation } from 'react-router-dom';

// Preserve search + hash so deep links like /metrics-guide#deployFrequency
// land on the same metric card after the rename (PRODOPSAI-371 AC1.3.2).
export function LegacyMetricsGuideRedirect() {
  const { search, hash } = useLocation();
  return <Navigate to={{ pathname: '/metric-catalogue', search, hash }} replace />;
}
